// a person's initials from their "Last, First" name: "Doe, John" gives "JD", a single name its first letter
export function getInitials(nameString: string): string {
  if (nameString == null)
    return null;

  //remove quotes in case there is a nickname in the nameString (and no firstname)
  nameString = nameString.replace(/["]/g, '');
  const fullName = nameString.split(', ');
  const initials = fullName.pop().charAt(0) + (fullName.length > 0 ? fullName.shift().charAt(0) : "");
  return initials.toUpperCase();
}
